import React from 'react';

import { ResetPassword } from '../components';
import LoginBase, { LoginBaseProps } from '../components/LoginBase';

export interface ResetPasswordPageProps extends LoginBaseProps {}

export const ResetPasswordPage: React.FC<ResetPasswordPageProps> = ({
  ...loginBaseProps
}) => {
  return (
    <LoginBase {...loginBaseProps}>
      <ResetPassword />
    </LoginBase>
  );
};
